import { render } from "./KryptonSearchableSelectOptionBox.vue?vue&type=template&id=19aa6fd7&lang=pug"
import script from "./KryptonSearchableSelectOptionBox.vue?vue&type=script&lang=js"
export * from "./KryptonSearchableSelectOptionBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__